import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export const RequestsBankOpsImportResultDialogSkeleton = () => {
  return (
    <Box mt={3}>
      <Skeleton height={24} variant="text" width="40%" />
      <Box>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton height={20} key={index} variant="text" width="100%" />
        ))}
      </Box>
    </Box>
  );
};
